import Title from "antd/es/typography/Title";
import { ApiToolCustomFieldsTable } from "components/Tables/ApiToolCustomFieldsTable/ApiToolCustomFieldsTable";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import IntegrationData = App.Data.IntegrationData;

interface IntegrationCustomFieldsSectionProps {
    integration: IntegrationData;
}

export const IntegrationCustomFieldsSection: FC<IntegrationCustomFieldsSectionProps> = ({ integration }) => {
    const { t } = usePaldockTranslation("forms.integration-custom-fields");
    
    return (
        <div>
            <Title level={3} className="mb-6">
                {t("sections.custom_fields.title")}
            </Title>
            <ApiToolCustomFieldsTable integration={integration} />
        </div>
    );
};
